// 리셋 CSS 는 다른 모든 CSS(App 하위 페이지 CSS 포함)보다 먼저 로드
import './styles/base.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import './styles/themeAdmin.css';
import './styles/themeUser.css';
import './styles/utilities.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
